import { render, staticRenderFns } from "./mobile-view.vue?vue&type=template&id=24f39810&scoped=true"
import script from "./mobile-view.vue?vue&type=script&lang=ts"
export * from "./mobile-view.vue?vue&type=script&lang=ts"
import style0 from "./mobile-view.vue?vue&type=style&index=0&id=24f39810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f39810",
  null
  
)

export default component.exports